import { HttpClient, HttpParams } from '@angular/common/http';
import { EventEmitter, Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { UserService } from '../../auth/_services/user.service';

const API_DPR_URL = '/api/dataRequests';
const API_DPR_ADD_URL = '/api/connector/dataPullRequest';
const API_UPLOAD_CSV = '/pyapi/uploadcsv'
const DQ_STATS = '/api/datadqstats'
const DELETE_SYSTEM_DATA='/api/system/delete-ts-data';
const API_URL = environment.API_URL;

@Injectable({
  providedIn: 'root'
})
export class DataSyncService {

  dprListChanged = new EventEmitter<any[]>();
  showStopButton = true
  PYTHON_API_URL;
  constructor(
    private readonly http: HttpClient,
    private readonly userService: UserService
  ) {
    this.PYTHON_API_URL = environment.runtime.PYTHON_API_URL;
  }

  getDPR(system, fields = null) {
    let httpParams = new HttpParams().set('system', system);

    if (fields) {
      httpParams = httpParams.set('fields', fields);
    }

    let url = API_URL + API_DPR_URL;

    this.http.get(url, { params: httpParams, headers: this.userService.getHttpAuthHeader() }).subscribe((data: any) => {
      let d = data.data;
      d.sort((x, y) => (x.dataReceived.from > y.dataReceived.from ? 1 : -1));
      this.dprListChanged.emit(d);
    });
  }

  addDPR(params) {
    return this.http.get(API_URL + API_DPR_ADD_URL, {params, headers: this.userService.getHttpAuthHeader()})
  }

  getDQstats(systemId, range) {
    let params = {
      system: systemId,
      from: range.from,
      to: range.to
    }
    return this.http.get(API_URL + DQ_STATS, { params, headers: this.userService.getHttpAuthHeader() })
  }

  addForTagDPR(params) {
    return this.http.post(API_URL + '/api/connector/dataPullRequest/tag', params, { headers: this.userService.getHttpAuthHeader() })
  }

  stopDataPull(system){
    let params = {
      system: system
    }
    return this.http.post(API_URL + API_DPR_ADD_URL +'/stop', params, { headers: this.userService.getHttpAuthHeader() })
  }
  uploadCsv(data, type) {
   return this.http.post(this.PYTHON_API_URL + API_UPLOAD_CSV + `?type=${type}`, data, { headers: this.userService.getHttpAuthHeader() })
  }

  deleteSystemData(system, deleteAll=false){
    let params = {
      system: system
    }
    if (deleteAll)
      params["delete"] = "all";
    return this.http.delete(API_URL + DELETE_SYSTEM_DATA, { params, headers: this.userService.getHttpAuthHeader() });
  }
}
